export const Reveal = () => {
    const revealElements = (selector, baseDelay = 0, incrementDelay = 150) => {
        const elements = document.querySelectorAll(selector);
        elements.forEach((element, index) => {
            const delay = baseDelay + index * incrementDelay;
            ScrollReveal().reveal(element, {
                reset: false,
                distance: "30px",
                easing: "ease-out",
                delay: delay,
            });
        });
    };
  
    ScrollReveal().reveal(".default-reveal", {
        delay: 100,
        reset: false,
    });
  
    revealElements(".div-reveal");
  };
  